module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp2_9005.3d49adcd.png";